export default "__VITE_ASSET__dc1eae10__"